import React from 'react'
import { Box, Stack, Heading, Text, Alert, Badge, FormField } from '@/components/lib'

const Code = ({ trial, fields, data, updateData }) => {
  return (
    <Stack gap={5}>
      <Stack gap={5}>
        <Box>
          <Heading as='h3' size='md'>Trial code <Badge colorPalette='yellow'>Required</Badge></Heading>
          <Text>The trial code is a word or phrase that your participants will use to login to the trial. It must be unique.</Text>
        </Box>
        <Alert><Text>We recommend using a short word that can easily be understood, memorised, and entered by participants later. For example, <strong>sleepquality</strong>.</Text></Alert>

        {fields.map(field =>
          <FormField key={field.label} label={field.label} type={field.type} value={data[field.key]} onChange={e => updateData({ [field.key]: e.target.value })} />
        )}
      </Stack>
    </Stack>
  )
}

export default Code
